import React from 'react';
import FormInput from './FormInput';

const StepPersonalInfo = ({ formData, handleInputChange }) => {
  return (
    <div className="animate-fadeIn">
      <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-2">
        Kişisel Bilgiler
      </h2>
      <p className="text-gray-600 mb-8">
        Lütfen kişisel bilgilerinizi eksiksiz ve doğru bir şekilde giriniz.
      </p>

      <div className="space-y-1">
        <FormInput
          label="Ad"
          name="firstName"
          value={formData.firstName}
          onChange={handleInputChange}
          placeholder="Adınızı giriniz"
          required
        />

        <FormInput
          label="Soyad"
          name="lastName"
          value={formData.lastName}
          onChange={handleInputChange}
          placeholder="Soyadınızı giriniz"
          required
        />

        <FormInput
          label="Doğum Tarihi"
          name="birthDate"
          type="date"
          value={formData.birthDate}
          onChange={handleInputChange}
          required
        />

        <FormInput
          label="T.C. Kimlik No"
          name="tcNo"
          type="text"
          inputMode="numeric"
          value={formData.tcNo}
          onChange={handleInputChange}
          placeholder="11 haneli TC kimlik numaranızı giriniz"
          maxLength="11"
          required
        />

        <FormInput
          label="Telefon Numarası"
          name="phoneNumber"
          type="tel"
          inputMode="tel"
          value={formData.phoneNumber}
          onChange={handleInputChange}
          placeholder="5XXXXXXXXX"
          maxLength="10"
          required
        />
      </div>

      <div className="mt-6 p-4 bg-primary-light border-l-4 border-primary/50 rounded-r-lg">
        <div className="flex">
          <svg className="h-5 w-5 text-primary flex-shrink-0 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
          <p className="ml-3 text-sm text-primary-text">
            Girdiğiniz bilgilerin resmi kimlik belgenizle uyumlu olduğundan emin olunuz.
          </p>
        </div>
      </div>
    </div>
  );
};

export default StepPersonalInfo;
